module.exports = __webpack_public_path__ + "img/10.0529993.png";